import { render, staticRenderFns } from "./leadInformation.vue?vue&type=template&id=36776444&scoped=true&"
import script from "./leadInformation.vue?vue&type=script&lang=js&"
export * from "./leadInformation.vue?vue&type=script&lang=js&"
import style0 from "./leadInformation.vue?vue&type=style&index=0&id=36776444&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36776444",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VForm,VTextField,VTextarea})
